/* Scroll reveal for homepage sections.
   Progressive enhancement: sections are visible by default; this script adds
   the hidden state and then reveals sections as they enter the viewport.
   Layered fallbacks guarantee content can never stay hidden, including in
   the Instagram / Facebook in-app browsers. */
(function () {
  'use strict';

  function init() {
    var main = document.getElementById('MainContent');
    if (!main || main.getAttribute('data-template') !== 'index') return;
    if (!('IntersectionObserver' in window) || !window.requestAnimationFrame) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var sections = main.querySelectorAll(':scope > .shopify-section');
    if (sections.length < 2) return;

    // Skip the first section (hero) so above-the-fold content is never delayed.
    var targets = Array.prototype.slice.call(sections, 1);

    document.documentElement.classList.add('scroll-reveal-enabled');
    targets.forEach(function (el) {
      el.classList.add('scroll-reveal');
    });

    var pending = targets.slice();
    var observer = null;

    function reveal(el) {
      el.classList.add('is-revealed');
      if (observer) observer.unobserve(el);
      var idx = pending.indexOf(el);
      if (idx > -1) pending.splice(idx, 1);
      if (!pending.length) detach();
    }

    function revealAllPending() {
      pending.slice().forEach(reveal);
    }

    try {
      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting || entry.intersectionRatio > 0) reveal(entry.target);
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
      );
      targets.forEach(function (el) {
        observer.observe(el);
      });
    } catch (e) {
      revealAllPending();
      return;
    }

    // Backup for browsers where IntersectionObserver callbacks stall
    // (known issue in the Instagram iOS in-app browser): a cheap
    // position check on scroll/resize reveals anything in view.
    var ticking = false;

    function checkPositions() {
      ticking = false;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      pending.slice().forEach(function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.top < vh * 0.95 && rect.bottom > 0) reveal(el);
      });
    }

    function onScrollOrResize() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(checkPositions);
      }
    }

    function detach() {
      window.removeEventListener('scroll', onScrollOrResize);
      window.removeEventListener('resize', onScrollOrResize);
    }

    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize);

    // Reveal anything already in the initial viewport even if the observer
    // never fires. Runs after load (and on a short timer) so measurements
    // happen against the settled layout, not the pre-image collapse.
    window.addEventListener('load', onScrollOrResize);
    window.setTimeout(onScrollOrResize, 1500);

    // Absolute failsafe: after this delay everything still pending is shown,
    // animated or not. Short leash inside in-app browsers.
    var inApp = /Instagram|FBAN|FBAV|FB_IAB/i.test(navigator.userAgent || '');
    window.setTimeout(revealAllPending, inApp ? 4000 : 12000);

    // Back/forward cache restore: show everything immediately.
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) {
        targets.forEach(function (el) {
          el.classList.add('is-revealed');
        });
        detach();
      }
    });
  }

  function safeInit() {
    try {
      init();
    } catch (e) {
      // Never let a failure here hide content; without the html class the
      // hidden styles do not apply.
      document.documentElement.classList.remove('scroll-reveal-enabled');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', safeInit);
  } else {
    safeInit();
  }
})();
